//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Comfort',
  data () {
    return {
      form: {
        alertness: '',
        calm: '',
        breath: '',
        physical: '',
        pressure: '',
        rate: '',
        muscle: '',
        tension: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '深睡眠'},
        {value: '2', name: '浅睡眠'},
        {value: '3', name: '昏昏欲睡'},
        {value: '4', name: '完全清醒或警觉'},
        {value: '5', name: '高度警惕'}
      ],
      dataList2: [
        {value: '1', name: '平静'},
        {value: '2', name: '轻度焦虑'},
        {value: '3', name: '焦虑'},
        {value: '4', name: '非常焦虑'},
        {value: '5', name: '惊恐'}
      ],
      dataList3: [
        {value: '1', name: '无咳嗽或无自主呼吸'},
        {value: '2', name: '有微弱的自主呼吸或对机械通气无反应'},
        {value: '3', name: '偶有咳嗽或呼吸对抗'},
        {value: '4', name: '呼吸对抗活跃，频繁咳嗽'},
        {value: '5', name: '严重呼吸对抗、咳嗽或憋气'}
      ],
      dataList4: [
        {value: '1', name: '无肢体活动'},
        {value: '2', name: '偶有轻微肢体活动'},
        {value: '3', name: '频繁有轻微肢体活动'},
        {value: '4', name: '四肢有活动'},
        {value: '5', name: '躯干及头部活动有力'}
      ],
      dataList5: [
        {value: '1', name: '低于基础值'},
        {value: '2', name: '保持在基础值'},
        {value: '3', shortName: '偶有升高15%或更多', name: '偶有升高15%或更多（观察期间出现1~3次）'},
        {value: '4', shortName: '频繁升高超过15%或更多', name: '频繁升高超过15%或更多（＞3次）'},
        {value: '5', name: '持续升高超过15%'}
      ],
      dataList6: [
        {value: '1', name: '低于基础值'},
        {value: '2', name: '保持在基础值'},
        {value: '3', shortName: '偶有升高15%或更多', name: '偶有升高15%或更多（观察期间出现1~3次）'},
        {value: '4', shortName: '频繁升高超过15%或更多', name: '频繁升高超过15%或更多（＞3次）'},
        {value: '5', name: '持续升高超过15%'}
      ],
      dataList7: [
        {value: '1', name: '肌肉完全放松，无张力'},
        {value: '2', name: '肌肉张力减弱'},
        {value: '3', name: '肌张力正常'},
        {value: '4', name: '肌张力增加，手指、脚趾弯曲'},
        {value: '5', name: '肌肉僵硬，手指、脚趾弯曲'}
      ],
      dataList8: [
        {value: '1', name: '面部肌肉完全放松'},
        {value: '2', name: '面部肌肉张力正常，无肌紧张'},
        {value: '3', name: '面部部分肌张力升高'},
        {value: '4', name: '面部全部肌肉张力升高'},
        {value: '5', name: '面部扭曲，表情痛苦'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (form[key] == '---') {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/Comfort.vue